import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { StackItemRoot, StackRoot } from './Stack.styled';
export const Stack = forwardRef(({ direction = 'row', gap = '2xl', wrap = false, alignment, contentAlign, children, ...rest }, ref) => (_jsx(StackRoot, { ref: ref, direction: direction, gap: gap, alignment: alignment, contentAlign: contentAlign, _wrap: wrap ? 'true' : undefined, ...rest, children: children })));
export const StackItem = forwardRef(({ children, ...rest }, ref) => (_jsx(StackItemRoot, { ref: ref, ...rest, children: children })));
Stack.displayName = 'Stack';
StackItem.displayName = 'StackItem';
//# sourceMappingURL=Stack.js.map